import { useCallback } from 'react';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { useUpdateCareProgramRequestMutation } from 'services/careProgramRequestService';

export interface UseMemberNotifiedAtResult {
  markMemberNotified: (requestId: string) => Promise<void>;
  isMarking: boolean;
}

export const useMemberNotifiedAt = (): UseMemberNotifiedAtResult => {
  const user = useLoggedInUser();
  const [updateCareProgramRequest, { isLoading }] = useUpdateCareProgramRequestMutation();

  const markMemberNotified = useCallback(
    async (requestId: string): Promise<void> => {
      const memberUuid = user?.uuid;
      if (!memberUuid) return;

      const memberNotifiedAt = new Date().toISOString();
      const payload = { memberUuid, id: requestId, memberNotifiedAt };
      try {
        await updateCareProgramRequest(payload).unwrap();
      } catch {
        // Swallow: fire-and-forget, member just sees the welcome sheet again next time.
      }
    },
    [user?.uuid, updateCareProgramRequest],
  );

  return { markMemberNotified, isMarking: isLoading };
};
